export const SET_AUTOCOMPLETE_SUGGESTIONS = 'SET_AUTOCOMPLETE_SUGGESTIONS';
export const SET_LOCATION_AUTOCOMPLETE_LOADING = 'SET_LOCATION_AUTOCOMPLETE_LOADING';
export const SET_LOCATION_AUTOCOMPLETE_READY = 'SET_LOCATION_AUTOCOMPLETE_READY';
export const SET_LOCATION_AUTOCOMPLETE_SEARCH = 'SET_LOCATION_AUTOCOMPLETE_SEARCH';
